import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"addchart"}/>
}
